<div class="card-table-notes" *ngIf="rowAccountNotesData.notes.length">
  <nf-table-layout
    hideTitle
    hideSearch
    [isSectionTitle]="false"
    [gridOptions]="gridOptionsAccountNotes"
    [data]="rowAccountNotesData.notes"
    hideClearAll
    [autoResizeGrid]="false"
    *nfLoader="loading"
  >
  </nf-table-layout>
</div>
<button
  nf-icon-button
  icon="plus"
  nf-icon-button="success"
  class="mdi-plus-circle"
  ngbTooltip="Add Note"
  (click)="onAddNote()"
>
  Add New Notes
</button>
